var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3271 14.6381C13.6147 14.0736 14.0736 13.6147 14.6381 13.3271C15.0165 13.1343 15.4097 13.063 15.8051 13.0307C16.1796 13.0001 16.6344 13.0001 17.1616 13.0001L21.7579 13.0001C22.1648 12.9997 22.5236 12.9993 22.872 13.083C23.1781 13.1565 23.4708 13.2777 23.7392 13.4422C24.0447 13.6294 24.2981 13.8833 24.5856 14.1713L32.3423 21.9281C32.9115 22.4973 33.3813 22.967 33.7327 23.381C34.0977 23.8109 34.3934 24.246 34.5617 24.764C34.8227 25.5674 34.8227 26.4328 34.5617 27.2362C34.3934 27.7542 34.0977 28.1893 33.7327 28.6192C33.3813 29.0332 32.9115 29.5029 32.3423 30.0721L30.0721 32.3423C29.5029 32.9115 29.0332 33.3813 28.6192 33.7327C28.1893 34.0977 27.7542 34.3934 27.2362 34.5617C26.4328 34.8227 25.5674 34.8227 24.764 34.5617C24.246 34.3934 23.8109 34.0977 23.381 33.7327C22.967 33.3813 22.4973 32.9115 21.9281 32.3423L14.1713 24.5856C13.8833 24.2981 13.6294 24.0447 13.4422 23.7392C13.2777 23.4708 13.1565 23.1781 13.083 22.872C12.9993 22.5236 12.9997 22.1648 13.0001 21.7579L13.0001 17.1616C13.0001 16.6344 13.0001 16.1796 13.0307 15.8051C13.063 15.4097 13.1343 15.0165 13.3271 14.6381ZM20.0001 18C18.8956 18 18.0001 18.8954 18.0001 20C18.0001 21.1046 18.8956 22 20.0001 22C21.1047 22 22.0001 21.1046 22.0001 20C22.0001 18.8954 21.1047 18 20.0001 18Z",
    fill: "#56AC14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountIcon);
export default __webpack_public_path__ + "static/media/discount_icon.06547be558933e4dcebd3c00915f382d.svg";
export { ForwardRef as ReactComponent };